import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { TextField, InlineError } from "@shopify/polaris";
import React from "react";
import useLocales from "../../../hooks/useLocales";

const RHFTextField = React.forwardRef(({ name, rules, ...other }, ref) => {
  const { control } = useFormContext();
  const { translate } = useLocales();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <>
          <TextField
            placeholder={translate("common.enter-value")}
            {...field}
            error={Boolean(error)}
            {...other}
            ref={ref}
          />
          {error && <InlineError message={error.message} fieldID={name} />}
        </>
      )}
    />
  );
});

RHFTextField.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
};

export default RHFTextField;
